import React, { Component } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import {Pie,Line,Bar } from 'react-chartjs-2';
import moment from 'moment';

class ServicesHome extends Component {

	constructor(props){
		super(props);

		this.state = {
			totalCases:0,
			openCases:0,
			resolvedCases:0,
			declineCases:0,
			approvedCases:0,
			daystoShow:""
		};

		this.option = {
			legend:{
				display: true,
				position: 'bottom',
				fullWidth: true,
				reverse: false,
			}
		};
		this.doughnut = {
		    labels: [
		        'Male',
		        'Female',
		        'Others',
		    ],
		    datasets: [{
		        data: [300, 50, 100],
		        backgroundColor: [
		            '#FF6384',
		            '#36A2EB',
		            '#FFCE56',
		        ]
		    }],
		};

		this.pie =  {
		    labels: [
		        'Open',
		        'Invalid',
		        'Resolved',
		    ],
		    datasets: [{
		        data: [300, 50, 100],
		        backgroundColor: [
		            '#FF6384',
		            '#36A2EB',
		            '#FFCE56',
		        ],
		        hoverBackgroundColor: [
		            '#FF6384',
		            '#36A2EB',
		            '#FFCE56',
		        ],
		    }],
		};

		this.line = {
				labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
	    		datasets: [{
    		     	label: 'No Of Cases',
	             	fill: false,
	             	lineTension: 0.1,
	             	backgroundColor: 'rgba(75,192,192,0.4)',
	             	borderColor: 'rgba(75,192,192,1)',
	             	borderCapStyle: 'butt',
	             	borderDash: [],
	             	borderDashOffset: 0.0,
	             	borderJoinStyle: 'miter',
	             	pointBorderColor: 'rgba(75,192,192,1)',
	             	pointBackgroundColor: '#fff',
	             	pointBorderWidth: 1,
	             	pointHoverRadius: 5,
	             	pointHoverBackgroundColor: 'rgba(75,192,192,1)',
	             	pointHoverBorderColor: 'rgba(220,220,220,1)',
	             	pointHoverBorderWidth: 2,
	             	pointRadius: 1,
	             	pointHitRadius: 10,
	             	data: [65, 59, 80, 81, 56, 55, 40],
	    		}]
		};

		this.optionsBar = {
 			legend: {
    			position: 'bottom',
			},
			scales:{
				yAxes:[{
					ticks: {
						stepSize: 1,
						min:0
					}
				}]
			}
		}

		this.bar = {
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
			datasets: [
				{
				label: 'No of Services',
				backgroundColor: 'rgba(255,99,132,0.2)',
				borderColor: 'rgba(255,99,132,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(255,99,132,0.4)',
				hoverBorderColor: 'rgba(255,99,132,1)',
				data: [65, 59, 80, 81, 56, 55, 40]
				}
			]
		}
	}

    componentDidMount() {
		this.computeStateOutOfprops();
	}
	
	componentWillReceiveProps = (prev) =>{
		this.computeStateOutOfprops();
	}

	computeStateOutOfprops = ()=>{
		let oStatus = {};
    	if(this.props.data.status){
    		oStatus = this.props.data.status;
		}

		this.filterDatedByRd();
    	
    	if(this.props.data.services){
    		let oServices = this.props.data.services,
    			aLables = Object.keys(oServices),
    			aData = [],aColor = [];
			for(let y in aLables){
				aData.push(oServices[aLables[y]]);
				aColor.push(this.generateRandomColor());
			}
			/* this.doughnut.labels = aLables; 
			this.doughnut.datasets[0].data = aData; 
			this.doughnut.datasets[0].backgroundColor = aColor;  */
			this.bar.labels = aLables; 
			this.bar.datasets[0].data = aData;
    	}

		this.pie.datasets[0].data = [oStatus[9] || 0,oStatus[11] || 0 ,oStatus[12] || 0];
    	this.setState({
    		totalCases:this.props.total,
    		openCases:(oStatus[9] || 0),
			resolvedCases:(oStatus[12] || 0),
			declineCases:(oStatus[11] || 0),
			approvedCases:(oStatus[10] || 0)
    	});
	}

    generateRandomColor = () => {
    	let r = Math.floor(Math.random() * 255),
			g = Math.floor(Math.random() * 255),
			b = Math.floor(Math.random() * 255),
			color = 'rgb(' + r + ', ' + g + ', ' + b + ')';
    	return color;
	}
	
	handleRdChange = (e) => {
		let {value} = e.target;
		this.filterDatedByRd(value);
	}


	filterDatedByRd = (p_val) => {
		if(this.props.data.dates){
			let oDates = this.props.data.dates,
				aLabels = Object.keys(oDates),
				nDaysToShow = p_val || 0,
				aFinalLabels = [],aFinalData = [];

			let prevDate = moment().subtract(nDaysToShow, 'days');	
			aLabels.sort((a,b) => {
				return new Date(a) - new Date(b);
			});

			for(let x in aLabels){
				/*  */
				let sTempDate = moment(aLabels[x],'DD-MMM-YY');
				if(!nDaysToShow || moment(sTempDate).isAfter(prevDate)){
					aFinalLabels.push(aLabels[x]);
					aFinalData.push(oDates[aLabels[x]]);
				}
			}
			this.line.labels = aFinalLabels;
			this.line.datasets[0].data = aFinalData;
			this.setState({
				daystoShow:p_val
			})
		}
	}

    render() {
        return (
            <div className='container-fluid my-4 '>
				<div className='row'>
					<div className='col-sm-12 col-md-6 col-lg-4'>
					 	<Card className="text-white bg-info">
					 		<CardBody className="pb-0 mb-4">
					 			<CardTitle>Total Cases</CardTitle>
					 			<i className="icon-book-open"></i>
					 			<div className="text-value">{this.state.totalCases}</div>
					 		</CardBody>
					 	</Card>
					</div>
					<div className='col-sm-12 col-md-6 col-lg-4'>
						<Card className="text-white bg-primary">
					 		<CardBody className="pb-0 mb-4">
					 			<CardTitle>Open Cases</CardTitle>
					 			<i className="icon-envelope-open"></i>
					 			<div className="text-value">{this.state.openCases}</div>
					 		</CardBody>
					 	</Card>
					</div>
					<div className='col-sm-12 col-md-6 col-lg-4'>
						<Card className="text-white bg-warning">
					 		<CardBody className="pb-0 mb-4">
				 				<CardTitle>Resolved Cases</CardTitle>
					 			<i className="icon-envelope"></i>
					 			<div className="text-value">{this.state.resolvedCases}</div>
					 		</CardBody>
					 	</Card>
					</div>
					<div className='col-sm-12 col-md-6 col-lg-4'>
						<Card className="text-white bg-danger">
					 		<CardBody className="pb-0 mb-4">
				 				<CardTitle>Declined Cases</CardTitle>
					 			<i className="icon-ban"></i>
					 			<div className="text-value">{this.state.declineCases}</div>
					 		</CardBody>
					 	</Card>
					</div>
					<div className='col-sm-12 col-md-6 col-lg-4'>
						<Card className="text-white bg-success">
					 		<CardBody className="pb-0 mb-4">
				 				<CardTitle>Approved Cases</CardTitle>
					 			<i className="icon-like"></i>
					 			<div className="text-value">{this.state.approvedCases}</div>
					 		</CardBody>
					 	</Card>
					</div>
				</div>
				<div className='row'>
					<div className='col-sm-12 col-md-12 col-lg-6'>
						<Card>
			              	<CardHeader>
				                Case Summary
			              	</CardHeader>
		              	 	<CardBody>
              	 				<div className="chart-wrapper">
									<Pie data={this.pie} 
										options={this.option}
			                    	/>
		                 	 	</div>
		              	 	</CardBody>
		              	</Card>
					</div>
					<div className='col-sm-12 col-md-12 col-lg-6'>
						<Card>
			              	<CardHeader>
				                Services Summary
			              	</CardHeader>
		              	 	<CardBody>
	              	 			<div className="chart-wrapper">
									<Bar data={this.bar}
										options={this.optionsBar} 
				                    />
			                  	</div>
		              	 	</CardBody>
		              	</Card>
					</div>
				</div>
				<div className="row">
					<div className='col-sm-12 col-md-12'>
						<Card>
			              	<CardHeader>
				                Monthly Cases Summary
			              	</CardHeader>
		              	 	<CardBody>
								<div className="row my-4">
									<div className="col-md-10 mx-auto text-right">
										<div className="form-check form-check-inline">
											<input className="form-check-input " type="radio" name="exampleRadios" id="rd_service_days_7" value="7" 
												checked={this.state.daystoShow === "7"}
												onChange={this.handleRdChange}
											/>
											<label className="form-check-label" htmlFor="rd_service_days_7">
												7 Days
											</label>
											</div>
											<div className="form-check form-check-inline">
											<input className="form-check-input" type="radio" name="exampleRadios" id="rd_service_days_30" value="30" 
												checked={this.state.daystoShow === "30"}
												onChange={this.handleRdChange}
											/>
											<label className="form-check-label" htmlFor="rd_service_days_30">
												30 Days
											</label>
											</div>
											<div className="form-check form-check-inline">
											<input className="form-check-input" type="radio" name="exampleRadios" id="rd_service_days_90" value="90"  
												checked={this.state.daystoShow === "90"}
												onChange={this.handleRdChange}
											/>
											<label className="form-check-label" htmlFor="rd_service_days_90">
												90 Days
											</label>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-md-11 mx-auto">
										<div className="chart-wrapper">
											<Line data={this.line}/>
										</div>

									</div>
								</div>
		              	 	</CardBody>
		              	</Card>
					</div>
				</div>
			</div>
        );
    }
}

export default ServicesHome;